export default function togglePreloader() {

  const $preloader = document.querySelector('.preloader'),
    $preloaderButton = document.querySelector('.show-preloader');

  if($preloader && $preloaderButton) {
    $preloaderButton.addEventListener('click', (event) => {
      event.preventDefault();
      $preloader.classList.add('preloader--active');
    });
  }
}